import React, { PropsWithChildren } from 'react'
import { ReactFC } from 'common/types/ReactFC'
import FeatureItem from 'components/FeatureItem'
import { Format } from 'common/utils/format'
import MediaCard from './common/MediaCard'

const features = [
  {
    description:
      'In 2022 alone, the UK saw the formation of 805,141 new companies, indicating a thriving entrepreneurial landscape.',
    title: 'Growing market.',
  },
  {
    description:
      'Our mail handling and digital document management solution makes digitisation available to even the smallest client and business. Removes the complexity of physical mail handling.',
    title: 'Digitisation.',
  },
  {
    description:
      'Our partners are seeing an average 46% year-on-year growth over the past three years.',
    title: 'Experience growth.',
  },
  {
    description: `For one of our clients, their customer base of 10K clients generate an additional ${Format.moneyShort(40000000)} per year with our registered office address solution.`,
    title: 'Revenue stream.',
  },
]

type TargetMarketAndGrowthType = {
  className?: string
}

const TargetMarketAndGrowth: ReactFC<
  PropsWithChildren<TargetMarketAndGrowthType>
> = ({ className = '' }) => {
  return (
    <MediaCard
      className={className}
      layout={{
        desktop: 'content-left-media-right',
        mobile: 'content-top-media-bottom',
      }}
      imageContainerWidth='50%'
      imageFitPreset='contain-center'
      image={{
        alt: 'HaiRo™ mail service with robot mascot and phone displaying mail interface',
        desktop: {
          src: '/images/new/robot-mail-preview.png',
          dimensions: { width: 678, height: 820 },
        },
        mobile: {
          src: '/images/new/robot-mail-preview.png',
          dimensions: { width: 678, height: 820 },
        },
      }}
    >
      <div className='pt-8 pt-lg-11 ps-4 ps-lg-20 pb-5 pb-lg-17 pe-4 pe-lg-0'>
        <h3 className='fs-fluid-36-80 fw-semibold mb-3 mb-lg-6 lh-105'>
          Target Market & Growth Potential.
        </h3>
        <div className='d-flex flex-column gap-5 fs-fluid-16-20'>
          {features.map((feature) => (
            <FeatureItem
              key={feature.title}
              title={feature.title}
              description={feature.description}
            />
          ))}
        </div>
      </div>
    </MediaCard>
  )
}

export default TargetMarketAndGrowth
